import { put, call, fork, take, takeLatest, takeEvery } from 'redux-saga/effects';

import { REQUEST } from 'redux-config/reduxHelpers';
import { acceptError } from 'common/_redux';

import * as api from '../../_api';
import * as ActionTypes from '../actions';
import { getNews } from '../../articles/api';

export function* getTradingAccountTypesSaga() {
  try {
    const { data } = yield call(api.getTradingAccountTypes);
    yield put(ActionTypes.getTradingAccountTypes.success(data));
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getTradingAccountTypes.failure(e));
  }
}

export function* getTradingAccountTypesWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_TRADING_ACCOUNT_TYPES[REQUEST]);
    yield call(getTradingAccountTypesSaga);
  }
}

export function* getAccountsPrefetchSaga(search) {
  try {
    const { status, data } = yield call(api.getAccountsPrefetch, search);
    if (status < 300) {
      yield put(ActionTypes.getAccountsPrefetch.success(data));
    } else {
      yield put(ActionTypes.getAccountsPrefetch.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getAccountsPrefetch.failure());
  }
}

export function* getAccountsPrefetchWatcherSaga() {
  while (true) {
    const { search } = yield take(ActionTypes.GET_ACCOUNTS_PREFETCH[REQUEST]);
    yield call(getAccountsPrefetchSaga, search);
  }
}

export function* getTradingAccountListSaga(noDetails, search) {
  try {
    const { status, data } = yield call(api.getTradingAccountList, search);
    if (status < 300) {
      yield put(ActionTypes.getTradingAccountList.success(data));
      if (!noDetails) {
        yield call(getAccountsPrefetchSaga, search);
      }
    } else {
      yield put(ActionTypes.getTradingAccountList.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getTradingAccountList.failure());
  }
}

export function* getTradingAccountListWatcherSaga() {
  while (true) {
    const { noDetails, search } = yield take(ActionTypes.GET_TRADING_ACCOUNT_LIST[REQUEST]);
    yield call(getTradingAccountListSaga, noDetails, search);
  }
}

export function* getTradingAccountSaga({ id }) {
  try {
    const { status, data } = yield call(api.getTradingAccount, id);
    if (status < 300) {
      yield put(ActionTypes.getTradingAccount.success(data));
    } else {
      yield put(ActionTypes.getTradingAccount.failure(status));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getTradingAccount.failure(id, e));
  }
}

export function* getTradingAccountWatcherSaga() {
  yield takeEvery(ActionTypes.GET_TRADING_ACCOUNT[REQUEST], getTradingAccountSaga);
}

export function* getTradingAccountOperationsSaga({ id, status = 'open', startDate, endDate, accountPlatformSlug }) {
  try {
    const response = yield call(api.getTradingAccountOperations, id, status, startDate, endDate, accountPlatformSlug);
    if (response.status < 300) {
      yield put(ActionTypes.getTradingAccountOperations.success(response.data));
    } else {
      yield put(ActionTypes.getTradingAccountOperations.failure(response.data));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getTradingAccountOperations.failure(id, e));
  }
}
export function* getTradingAccountOperationsWatcherSaga() {
  yield takeLatest(ActionTypes.GET_TRADING_ACCOUNT_OPERATIONS[REQUEST], getTradingAccountOperationsSaga);
}

export function* getPartnerAccountsSaga({ referType }) {
  try {
    const { data } = yield call(api.getPartnerAccounts, referType);
    yield put(ActionTypes.getPartnerAccounts.success(data));
    for (let i = 0; i < data.length; i += 1) {
      yield put(ActionTypes.getPartnerAccount.request(data[i].id));
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getPartnerAccounts.failure(e));
  }
}
export function* getPartnerAccountsWatcherSaga() {
  while (true) {
    const { data } = yield take(ActionTypes.GET_PARTNER_ACCOUNTS[REQUEST]);
    yield fork(getPartnerAccountsSaga, data);
  }
}

export function* getPartnerAccountSaga({ accountId }) {
  try {
    const { data } = yield call(api.getPartnerAccount, accountId);
    yield put(ActionTypes.getPartnerAccount.success(accountId, data));
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getPartnerAccount.failure(accountId, e));
  }
}
export function* getPartnerAccountWatcherSaga() {
  yield takeEvery(ActionTypes.GET_PARTNER_ACCOUNT[REQUEST], getPartnerAccountSaga);
}

export function* getPartnerAccountCommissionsSaga({ accountId, search }) {
  search = search.search ? search.search : search;
  try {
    const { data } = yield call(api.getPartnerAccountCommissions, accountId, search);
    yield put(ActionTypes.getPartnerAccountCommissions.success(data));
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getPartnerAccountCommissions.failure());
  }
}
export function* getPartnerAccountCommissionsWatcherSaga() {
  while (true) {
    const data = yield take(ActionTypes.GET_PARTNER_ACCOUNT_COMMISSIONS[REQUEST]);
    yield call(getPartnerAccountCommissionsSaga, data);
  }
}

export function* getMTServersSaga() {
  try {
    const { data } = yield call(api.getMTServersAPI);
    yield put(ActionTypes.getMTServersAction.success(data));
  } catch (error) {
    yield put(ActionTypes.getMTServersAction.failure(error));
  }
}
export function* getMTServersWatcherSaga() {
  yield takeEvery(ActionTypes.GET_MT_SERVERS_ACTION[REQUEST], getMTServersSaga);
}

export function* getMTServersNewSaga() {
  try {
    const { data } = yield call(api.getMTServersNewAPI);
    yield put(ActionTypes.getMTServersActionNew.success(data));
  } catch (error) {
    yield put(ActionTypes.getMTServersActionNew.failure(error));
  }
}
export function* getMTServersNewWatcherSaga() {
  yield takeEvery(ActionTypes.GET_MT_SERVERS_ACTION_NEW[REQUEST], getMTServersNewSaga);
}

export function* getClientCountersSaga() {
  try {
    const { status, data } = yield call(getNews, { limit: 1 });
    if (status < 300) {
      let counter = '';
      const createdDate = data.count > 0 ? data.results[0].created : null;
      const lastRead = localStorage.getItem('last_read');
      if (!createdDate) {
        counter = '';
        localStorage.removeItem('last_read');
      }
      if (createdDate && (!lastRead || createdDate > lastRead)) {
        counter = ' ';
      }
      yield put(ActionTypes.getClientCounters.success(counter));
    } else {
      yield put(ActionTypes.getClientCounters.failure(data));
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getClientCounters.failure(e));
    throw e;
  }
}

export function* getClientCountersWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_CLIENT_COUNTERS[REQUEST]);
    yield call(getClientCountersSaga);
  }
}

export function* updateClientCountersSaga({ data }) {
  const createdDate = data.count > 0 ? data.results[0].created : null;
  const lastRead = localStorage.getItem('last_read');
  if (createdDate && (!lastRead || createdDate > lastRead)) {
    localStorage.setItem('last_read', createdDate);
  }
  yield put(ActionTypes.updateClientCounters.success(''));
}

export function* updateClientCountersWatcherSaga() {
  yield takeLatest(ActionTypes.UPDATE_CLIENT_COUNTERS[REQUEST], updateClientCountersSaga);
}

export default [
  fork(getTradingAccountTypesWatcherSaga),
  fork(getTradingAccountListWatcherSaga),
  fork(getAccountsPrefetchWatcherSaga),
  fork(getTradingAccountWatcherSaga),
  fork(getTradingAccountOperationsWatcherSaga),
  fork(getPartnerAccountsWatcherSaga),
  fork(getPartnerAccountWatcherSaga),
  fork(getPartnerAccountCommissionsWatcherSaga),
  fork(getMTServersWatcherSaga),
  fork(getMTServersNewWatcherSaga),
  fork(getClientCountersWatcherSaga),
  fork(updateClientCountersWatcherSaga),
];
